const inicialState = {
    laminas: [],
    moverDisabled: true,
    modal: false,
    novasLaminas: false, 
    destinos: [], 
    lista:[]
  };
  
  export default inicialState;


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/store/organizar.state.js